import {Image} from '@yandex-delivery/blocks'
import {flow, get} from '@yandex-delivery/utils'
import type {FC, ReactElement} from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import type {IconSpotWidgetProps as Props} from '../types'

export const IconSpotWidget: FC<Props> = //
  flow(
    get('config.icon_spot.icon.image_tag'), //
    tagToUrl,
    (src: string): ReactElement => <Image alt="" height={24} src={src} />,
  )
IconSpotWidget.displayName = 'IconSpotWidgetDesktop'
